import { RightOutlined } from "@ant-design/icons";
import {t, Trans} from "@lingui/macro";
import { Row, Col, Tag } from "antd";
import React, { useLayoutEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { css } from "styled-components";
import Hotkeys from "react-hot-keys";
import queryString from 'query-string';
import FormatNumber from "bukku/components//FormatNumber";
import TransactionType from "bukku/components//TransactionType";
// import Moment from "moment";
import dayjs from 'dayjs';
import {
    getKeysString,
    hotkeyAction,
    hotkeyToAction,
    isCurrentEventAHotkey,
} from "../helper.hotkeys";
import {TransactionUrl} from "../../../redux/Transaction/helpers/TransactionUrl";

export const SearchResultsStyles = css`

  .search-group__header {
    display: flex;
    justify-content: space-between;
    margin: 8px 8px 5px;
    font-size: 11px;
    font-weight: 500;
    /* stylelint-disable-next-line number-max-precision */
    line-height: 1.45454545;
    color: #8993a4;
    text-transform: uppercase;
  }

  ul.searchDirectory__option-list {
    /* padding: 0px 0px; */
    padding-left: 0;

    li {
      padding: 3.5px 20px;

      .ant-row {
        align-items: center;

        .label {
          font-weight: 500;
          color: black;

          /* horizontal line */
          .label__details::before {
            position: relative;
            display: inline-block;
            width: 0.8rem;
            height: 1px;
            margin-right: 6px;
            vertical-align: middle;
            content: "";
            background-color: #8c8c8c;

           
          }

          .label__details {
            font-weight: 400;
            color: #8c8c8c;

            &.page-keyword {
                margin-left: 11px;
            }

            &.transaction-info {
                margin-left: -3px;
            }
          } 
        }

        .icon-right {
          color: #bfbfbf;
        }
      }

      /* :hover {
        background-color: #fafafa;
      } */

      :hover,
      :active,
      :focus,
      &.is-active-cursor
      /* :focus-visible, */
      /* :focus-within */ {
        transition: background-color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

        /* mouse hover */
        &:not(.is-active-cursor) {
            padding-left: 20px;
            background-color: #fafafa;
            border-left: none;
        }

        /* keyboard-focus */
        &.is-active-cursor {
            /* override searchDirectory__option-list li's padding for border-left */
            padding-left: 16px;
            background-color: #f0f0f0;
            border-left: 4px solid #1FB6C6; 
        }

        .label,
        .icon-right {
          color: #1890ff; /* blue-6 */

          .label__details::before {
            height: 1.3px;

            /* background-color: #1890ff; */
          }

          .label__details {
            font-weight: 500;
          }
        }

        /* .icon-right {
          color: #262626;
        } */
      }
    }
  }
`;

export function SearchResults({ searchResults, visible, clearAndCloseModal }) {
    // const MAX_PAGES_RESULTS_SHOWN = 10;
    const [activeIndex, setActiveIndex] = useState(null);
    const history = useHistory();
    const {
        pages: pagesSearchResults,
        transactions: transactionsSearchResults,
    } = searchResults;

    const totalResults = pagesSearchResults.length + transactionsSearchResults.length;

    useLayoutEffect(() => {
        setActiveIndex(0);
        return () => {
            setActiveIndex(null);
        };
    }, [searchResults]);

    const getLinkTo = (fusePageItem, withQuery, searchLabel) => {
        // console.log('aaa getLinkTo', {fusePageItem, withQuery, searchLabel});
        const {
            globalSearchKeywords,
            key,
        } = fusePageItem;

        // eg: {type: 'supplier'}
        const globalSearchKeyword = globalSearchKeywords
            ?.find(keyword => keyword.searchLabel === searchLabel);
        const queryObject = globalSearchKeyword?.queryString;
        const overrideFullUrl = globalSearchKeyword?.overrideFullUrl;
        // console.log('aaa getLinkTo', {globalSearchKeywords, globalSearchKeyword, queryObject, overrideFullUrl});

        if (!globalSearchKeywords || (!queryObject && !overrideFullUrl) || !withQuery) {
            return {
                url: key,
                paramString: null,
                fullUrl: `${key}`,
            };
        }

        // console.log('aaa queryObject', queryObject);
        const paramString = queryString.stringify(queryObject, { arrayFormat: 'bracket' });
        // return `${key}?${paramString}`;

        return {
            url: key,
            paramString,
            fullUrl: overrideFullUrl || `${key}?${paramString}`,
        };
    };

    // eslint-disable-next-line no-unused-vars
    const onKeyUp = (keyName, e, handle) => {
        switch (hotkeyToAction[keyName]) {
            case hotkeyAction.RESULT_GO_UP:
                setActiveIndex(activeIndex => (activeIndex > 0 ? activeIndex - 1 : 0));
                break;
            case hotkeyAction.RESULT_GO_DOWN:
                setActiveIndex(activeIndex => (activeIndex < totalResults - 1 ?
                    activeIndex + 1 :
                    totalResults - 1));
                break;
            case hotkeyAction.ENTER_RESULT:
                // console.log('aaa activeindex', {
                //     activeIndex, pagesSearchResults, transactionsSearchResults, totalResults});
                if (activeIndex !== null && totalResults) {
                    // navigate to pages
                    if (activeIndex < pagesSearchResults.length) {
                        console.log('test HIT ENTER',
                            {activeIndex, result: pagesSearchResults[activeIndex]});
                        const activeItem = pagesSearchResults[activeIndex].item;
                        const fuseMatchesArray = pagesSearchResults[activeIndex].matches;
                        const {value: matchedValue} = fuseMatchesArray[0];

                        // eg: 'manual recon' is not in 'Bank Recon' label
                        const onlyMatchedKeywords = fuseMatchesArray.every(match => (
                            match.key === 'globalSearchKeywords.searchLabel' ||
                                match.key === 'globalSearchBaseLabel'),
                        );
                        const {fullUrl} = getLinkTo(activeItem, onlyMatchedKeywords, matchedValue);

                        // open in new tab
                        if (activeItem.linkProps?.target === '_blank') {
                            window.open(
                                fullUrl,
                                // getLinkTo(activeItem, onlyMatchedKeywords, matchedValue),
                                activeItem.linkProps.target,
                                activeItem.linkProps.rel,
                            );
                        }
                        else {
                            // open in same tab
                            history.push(fullUrl);
                            // history.push(getLinkTo(activeItem, onlyMatchedKeywords, matchedValue));
                        }
                    }
                    // view transaction
                    else {
                        const transaction =
                                transactionsSearchResults[activeIndex - pagesSearchResults.length];
                            // console.log('test HIT ENTER', {activeIndex, result: transaction});
                        const url = TransactionUrl.view(transaction.type, transaction.id);
                        history.push(url);
                    }
                    clearAndCloseModal();
                }
                break;
            default:
                break;
        }
    };

    const getParentLabelTagColor = parentLabel => {
        switch (parentLabel) {
            case t`Sales`:
                return 'green';
            case t`Purchases`:
                return 'red';
            case t`Bank`:
                return 'gold';
            case t`Reports`:
                return 'cyan';
            default:
                return null;
        }
    };

    // prevent browser default action of UP DOWN keys changing input cursor position
    const onKeyDown = (keyName, event) => {
        const filteredKeys = [
            hotkeyAction.ENTER_RESULT, hotkeyAction.RESULT_GO_DOWN,
            hotkeyAction.RESULT_GO_UP,
        ];
        if (isCurrentEventAHotkey(event, filteredKeys))
            event.preventDefault();
    };

    return (
        <Hotkeys
            keyName={getKeysString([
                hotkeyAction.ENTER_RESULT,
                hotkeyAction.RESULT_GO_DOWN,
                hotkeyAction.RESULT_GO_UP,
            ])}
            onKeyUp={onKeyUp}
            onKeyDown={onKeyDown}
            filter={() => true}
            // filter={event => {
            //     // console.log('test filter', event);
            //     // if (
            //     //     (document.activeElement.id === 'global_search_input') &&
            //     //     actionToHotkey[hotkeyAction.TOGGLE_GLOBAL_SEARCH_SLASH].eventCheck(event))
            //     //     return false;
            //     // return true;
            //     const filteredKeys = [
            //         hotkeyAction.ENTER_RESULT, hotkeyAction.RESULT_GO_DOWN,
            //         hotkeyAction.RESULT_GO_UP,
            //         // hotkeyAction.TOGGLE_GLOBAL_SEARCH_SLASH,
            //         // hotkeyAction.TOGGLE_GLOBAL_SEARCH_ALT_SPACE,
            //     ];
            //     if (isCurrentEventAHotkey(event, filteredKeys)) {
            //         // prevent up down keys from changing cursor position in searchbar,
            //         if (
            //             (document.activeElement.id === 'global_search_input') &&
            //             (actionToHotkey[hotkeyAction.RESULT_GO_UP].eventCheck(event) ||
            //             actionToHotkey[hotkeyAction.RESULT_GO_DOWN].eventCheck(event))
            //         ) {
            //             event.stopPropagation();
            //             event.preventDefault();
            //         }
            //         return true;
            //     }
            //     return false;
            // }}
        // className={className}
        >
            <div className="search-group--pages">
                {
                    pagesSearchResults.length ?
                        <ul
                            className={`searchDirectory__option-list ${
                                !visible ? "display-none" : ""
                            }`}
                        >
                            <div className="search-group__header"><Trans>Pages</Trans></div>
                            {
                                //only max of 10 results are shown
                                pagesSearchResults.map((result, idx) => {
                                    console.log('aaa result', result);
                                    const fuseOption = result.item;
                                    const fuseMatchesArray = result.matches;

                                    // eg: 'manual recon' is not in 'Bank Recon' label
                                    const onlyMatchedKeywords = fuseMatchesArray
                                        .every(match => (
                                            match.key === 'globalSearchKeywords.searchLabel' ||
                                            match.key === 'globalSearchBaseLabel'),
                                        );

                                    const {key, label, parentLabel, linkProps} = fuseOption;
                                    const {value: matchedValue} = fuseMatchesArray[0];
                                    const isActiveCursor = activeIndex === idx;
                                    const {
                                        url, paramString,
                                    } = getLinkTo(fuseOption, onlyMatchedKeywords, matchedValue);

                                    // console.log('aaa matchedValue', matchedValue);
                                    return (
                                        <li
                                            key={key}
                                            className={`${isActiveCursor ? "is-active-cursor" : ""}`}
                                        >
                                            <Link
                                                to={{
                                                    pathname: url,
                                                    search: paramString ? `?${paramString}` : '',
                                                }}
                                                onClick={() => clearAndCloseModal()}
                                                {...linkProps}
                                            >
                                                <Row justify="space-between">
                                                    <Col flex="1 0 220px" className="ellipsis-div label">
                                                        {parentLabel ? (
                                                            <Tag color={getParentLabelTagColor(parentLabel)}>
                                                                {parentLabel}
                                                            </Tag>) : null}
                                                        {label}
                                                        {
                                                            onlyMatchedKeywords ?
                                                                <span className="label__details page-keyword">
                                                                    {matchedValue}
                                                                </span> : null
                                                        }
                                                    </Col>
                                                    <Col flex="0 0 15px" className="icon-right">
                                                        <RightOutlined />
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </li>
                                    );
                                })
                            }
                        </ul> :
                        null
                }

                {/* Transactions */}
                {transactionsSearchResults.length ?
                    <ul
                        className={`searchDirectory__option-list ${
                            !visible ? "display-none" : ""
                        }`}
                    >
                        <div className="search-group__header"><Trans>Transactions</Trans></div>
                        {/* //only first 10 results are shown */}
                        {transactionsSearchResults.map((record, idx) => {
                            const newIdx = pagesSearchResults.length + idx;
                            const isActiveCursor = activeIndex === newIdx;
                            const url = TransactionUrl.view(record.type, record.id);

                            return (
                                <li
                                    key={record.id}
                                    className={`${isActiveCursor ? "is-active-cursor" : ""}`}
                                >
                                    <Link to={url}>
                                        <Row justify="space-between">
                                            <Col flex="1 0 220px" className="ellipsis-div label">
                                                <span>
                                                    {record.number}
                                                    &nbsp;
                                                    <span style={{marginInlineEnd: "8px"}}>
                                                        <TransactionType record={record} />
                                                    </span>
                                                </span>
                                                <span className="label__details transaction-info">
                                                    <span>{dayjs(record.date).format('DD/MM/YYYY')}</span>
                                                    &nbsp;&bull;&nbsp;
                                                    <span>{record.contact_name}</span>
                                                    &nbsp;&bull;&nbsp;
                                                    <FormatNumber
                                                        currency={record.currency_symbol}
                                                        amount={record.amount}
                                                    />
                                                </span>
                                            </Col>
                                            <Col flex="0 0 15px" className="icon-right">
                                                <RightOutlined />
                                            </Col>
                                        </Row>
                                    </Link>
                                </li>
                            );
                        })}
                    </ul> :
                    null}
            </div>
        </Hotkeys>
    );
}
